/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ChartType } from '@models/chart.model';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-datalabels-color',
  templateUrl: './theme-option-datalabels-color.component.html',
  styleUrls: ['./theme-option-datalabels-color.component.css']
})
export class ThemeOptionDatalabelsColorComponent {

  @Input() themeOptions: ThemeOptionsClass;
  @Input() datalabelsIndex: number;

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'datalabels_color';
  showDetails: boolean;

  constructor() {}

  receiveShowDetails(showDetails: boolean) {
    this.showDetails = showDetails;
  }

  receiveValue(value: string, type?: ChartType) {
    this.themeOptions.setDatalabels(this.optionType, value, this.datalabelsIndex, type ? [type] : undefined);
  }

}
